import cn from 'classnames'
import { Status } from './types/types'

// Assets
import { ReactComponent as StatusApprovedIcon } from 'images/icons/icon-status-approved.svg'
import { ReactComponent as StatusFlaggedIcon } from 'images/icons/icon-status-flagged.svg'
import { ReactComponent as StatusRejectedIcon } from 'images/icons/icon-status-rejected.svg'

import styles from './Pill.module.scss'

type PillProps = {
  status?: string
  approvedAmount?: number | null
  textOverride?: string
}

const Pill: React.FC<PillProps> = (props) => {
  const { status, approvedAmount, textOverride } = props

  let statusData

  switch (status) {
    case Status.APPROVED:
      statusData = {
        icon: <StatusApprovedIcon width={18} height={18} />,
        styles: styles.containerApproved,
        text: 'Mint Links Approved',
      }
      break
    case Status.FLAGGED:
      statusData = {
        icon: <StatusFlaggedIcon width={18} height={18} />,
        styles: styles.containerFlagged,
        text: 'Flagged',
      }
      break
    case Status.REJECTED:
      statusData = {
        icon: <StatusRejectedIcon width={18} height={18} />,
        styles: styles.containerRejected,
        text: 'Rejected',
      }
      break
    default:
      statusData = {
        styles: styles.containerPending,
        text: 'Nobody has reviewed this request yet',
      }
      break
  }

  if (textOverride) {
    statusData.text = textOverride
  }

  const showAmount = status === Status.APPROVED && approvedAmount
  const textContent = showAmount ? `${approvedAmount} ${statusData.text}` : statusData.text

  return (
    <div className={cn(styles.container, statusData.styles)} data-test-id="pill_container">
      <div className={styles.content}>
        {statusData?.icon}
        <label className={styles.label} data-test-id="pill_label">
          {textContent}
        </label>
      </div>
    </div>
  )
}

export default Pill
